// utils/seo.js
// 更好的方式：直接传入语言标识和语言包
import zh from '@/lang/zh';
import en from '@/lang/en';

const allMessages = { zh, en };

export function updateGlobalSeo(locale) {
  const langPack = allMessages[locale];
  if (!langPack || !langPack.globalSeo) return;

  const seo = langPack.globalSeo;
  document.title = seo.title;

  let descMeta = document.querySelector('meta[name="description"]');
  if (!descMeta) {
    descMeta = document.createElement('meta');
    descMeta.setAttribute('name', 'description');
    document.head.appendChild(descMeta);
  }
  descMeta.setAttribute('content', seo.description);

  let keywordsMeta = document.querySelector('meta[name="keywords"]');
  if (!keywordsMeta) {
    keywordsMeta = document.createElement('meta');
    keywordsMeta.setAttribute('name', 'keywords');
    document.head.appendChild(keywordsMeta);
  }
  keywordsMeta.setAttribute('content', seo.keywords);
}


// WEBPACK FOOTER //
// ./src/utils/seo.js